import { WebPage as WebPageSchema } from 'schema-dts'

import { escapeHtmlForJsonLd } from '../../helpers/StringHelpers'

export const jsonLdWebPage = (
  name: string,
  description: string,
  mainImage: string
): WebPageSchema => {
  return {
    '@type': 'WebPage',
    name,
    description: escapeHtmlForJsonLd(description),
    primaryImageOfPage: {
      '@type': 'ImageObject',
      contentUrl: mainImage,
      name,
    },
  }
}
